(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alpaca-atajos"] && !Shopify.designMode) return;
  try {
    (function () {
    var AVISO = 'https://efqmzvrxasvdigybsksf.supabase.co/functions/v1/whatsapp-toque';

    function origen() {
      try {
        var o = JSON.parse(localStorage.getItem('alpaca_origen') || 'null');
        if (o && o.t && Date.now() - o.t < 2592e6) return o;
      } catch (e) {}
      return {};
    }

    function codigo() {
      var a = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', s = '', r;
      try { r = crypto.getRandomValues(new Uint8Array(5)); } catch (e) { r = [1, 2, 3, 4, 5].map(function () { return Math.floor(Math.random() * 256); }); }
      for (var i = 0; i < 5; i++) s += a.charAt(r[i] % a.length);
      return s;
    }

    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target : null;
      if (!t) return;

      /* Pedir por WhatsApp: número de consulta + aviso a nuestra base */
      var wa = t.closest('[data-alp-wa]');
      if (wa) {
        try {
          var titulo = wa.getAttribute('data-titulo') || '', vtit = wa.getAttribute('data-variante') || '';
          var c = codigo(), o = origen();
          var inicio = wa.hasAttribute('data-agotado') ? 'Hola, quiero que me avisen cuando vuelva: ' : 'Hola, me interesa: ';
          var msg = inicio + titulo + (vtit ? ' (' + vtit + ')' : '') + '. Consulta ' + c;
          wa.href = 'https://wa.me/' + (wa.getAttribute('data-telefono') || '593987878444') + '?text=' + encodeURIComponent(msg);
          var cuerpo = JSON.stringify({
            consulta: c,
            producto_handle: wa.getAttribute('data-handle') || '',
            producto_titulo: titulo,
            variante_id: Number(wa.getAttribute('data-variante-id')) || null,
            variante_titulo: vtit,
            pagina: location.pathname,
            utm_source: o.utm_source || '', utm_medium: o.utm_medium || '', utm_campaign: o.utm_campaign || '',
            utm_content: o.utm_content || '', utm_term: o.utm_term || '',
            con_fbclid: o.con_fbclid === true, referente: o.referente || ''
          });
          if (!(navigator.sendBeacon && navigator.sendBeacon(AVISO, new Blob([cuerpo], { type: 'text/plain' })))) {
            fetch(AVISO, { method: 'POST', body: cuerpo, headers: { 'Content-Type': 'text/plain' }, keepalive: true, mode: 'cors' }).catch(function () {});
          }
        } catch (e) {}
        return;
      }

      /* Comprar ahora: agrega al carrito (sin borrar lo que ya había) y va directo al pago.
         Si algo falla, el enlace normal de carrito sigue funcionando. */
      var ca = t.closest('[data-alp-comprar-ahora]');
      if (ca && window.fetch) {
        ev.preventDefault();
        if (ca.getAttribute('aria-busy') === 'true') return;
        ca.setAttribute('aria-busy', 'true');
        var sec = ca.closest('.shopify-section') || document;
        var q = sec.querySelector('input[name="quantity"]');
        var n = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        /* Lo que la persona marcó en la ficha (por ejemplo, "Es para regalo" y su mensaje) viaja con la prenda. */
        var item = { id: Number(ca.getAttribute('data-variante-id')), quantity: n };
        var props = {};
        sec.querySelectorAll('[name^="properties["]').forEach(function (el) {
          if (el.disabled || !el.value) return;
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          var k = el.name.slice(11, -1);
          if (k) props[k] = el.value;
        });
        if (Object.keys(props).length) item.properties = props;
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) throw new Error('carrito');
          location.href = raiz + 'checkout';
        }).catch(function () {
          location.href = ca.href;
        });
      }
    }, true);

    /* Agotada o no: la marca [data-alp-estado-agotado] (la pone el precio, blocks/alpaca-precio) decide qué se ve.
       [data-alp-si-hay] (envío, «llega…», regalo, «Arma el regalo», compra de la historia) se esconde si está agotada;
       [data-alp-si-agotado] (las líneas «Cuando vuelva…» de la historia) solo se ve si está agotada.
       El Liquid ya los pinta bien al cargar; esto los cambia en vivo al elegir otra talla. */
    function sincronizarAgotado() {
      var agotado = !!document.querySelector('[data-alp-estado-agotado]');
      document.documentElement.classList.toggle('alp-agotado', agotado);
      document.querySelectorAll('[data-alp-si-hay]').forEach(function (el) { el.hidden = agotado; });
      document.querySelectorAll('[data-alp-si-agotado]').forEach(function (el) { el.hidden = !agotado; });
      try { document.dispatchEvent(new CustomEvent('alpaca:agotado', { detail: { agotado: agotado } })); } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sincronizarAgotado);
    else sincronizarAgotado();

    /* Al cambiar de variante, Horizon trae la sección nueva: copiamos nuestras piezas "vivas". */
    document.addEventListener('shopify:product:select', function (ev) {
      if (!ev.promise || !ev.promise.then) return;
      ev.promise.then(function (r) {
        var html = r && r.detail && r.detail.html;
        if (!html || !html.querySelector) return;
        document.querySelectorAll('[data-alp-vivo]').forEach(function (el) {
          var nuevo = html.querySelector('[data-alp-vivo="' + el.getAttribute('data-alp-vivo') + '"]');
          if (nuevo) el.innerHTML = nuevo.innerHTML;
        });
        /* Los enlaces de WhatsApp fuera de las piezas vivas (la historia de abajo) también pasan a la talla elegida. */
        var va = r.detail.resource;
        if (va && va.id) {
          document.querySelectorAll('[data-alp-wa][data-variante-id]').forEach(function (a) {
            a.setAttribute('data-variante-id', va.id);
            if (a.getAttribute('data-variante') && va.title) a.setAttribute('data-variante', va.title);
            if (va.available === false) a.setAttribute('data-agotado', '');
            else if (!a.hasAttribute('data-alp-wa-avisa')) a.removeAttribute('data-agotado');
          });
        }
        sincronizarAgotado();
      }).catch(function () {});
    });

    /* La barra de compra fija (celular y compu) aparece solo cuando el botón principal ya salió de la
       pantalla por arriba, y se esconde mientras se ven el botón, la historia «Del telar a tu puerta»
       (que tiene su propio «Agregar al carrito») o el pie. Estados en <html data-alp-compra>:
       antes · visible · historia · fuera (solo «fuera» muestra la barra; ver snippets/alpaca-ficha). */
    function vigilarBoton() {
      var boton = document.querySelector('.product-details .buy-buttons-block');
      if (!boton || !('IntersectionObserver' in window)) return;
      var pie = document.querySelector('footer'), historias = document.querySelectorAll('.alp-hf [data-alp-hf-pista]');
      var enBoton = true, pasado = false, enPie = false, enHf = {};
      function pintar() {
        var hf = Object.keys(enHf).some(function (k) { return enHf[k]; });
        var e = enBoton || enPie ? 'visible' : !pasado ? 'antes' : hf ? 'historia' : 'fuera';
        if (document.documentElement.getAttribute('data-alp-compra') !== e) document.documentElement.setAttribute('data-alp-compra', e);
      }
      new IntersectionObserver(function (es) {
        var x = es[es.length - 1];
        enBoton = x.isIntersecting;
        /* «Pasado»: el botón quedó entero por encima de la pantalla. */
        pasado = !x.isIntersecting && x.boundingClientRect.bottom <= 0;
        pintar();
      }).observe(boton);
      if (pie) new IntersectionObserver(function (es) { enPie = es[es.length - 1].isIntersecting; pintar(); }).observe(pie);
      historias.forEach(function (h, i) {
        new IntersectionObserver(function (es) { enHf[i] = es[es.length - 1].isIntersecting; pintar(); }).observe(h);
      });
      pintar();
    }
    /* Computadora: la columna de compra se queda a la vista mientras se miran las fotos.
       Si es más alta que la pantalla, se pega por abajo: así el botón nunca queda escondido. */
    function columnaFija() {
      var col = document.querySelector('.product-information .product-details.sticky-content--desktop');
      if (!col || !window.matchMedia) return;
      var mq = window.matchMedia('(min-width: 750px)');
      function ajustar() {
        if (!mq.matches) { col.style.top = ''; return; }
        /* Lo que sobra abajo si la columna se pega arriba. Si el encabezado (que aparece al subir) no deja
           ver el final de la columna, la columna sube lo justo: el final nunca queda cortado. */
        var limite = window.innerHeight - col.offsetHeight - 16;
        col.style.top = limite < 96 ? 'min(var(--sticky-header-offset, 0px), ' + limite + 'px)' : '';
      }
      ajustar();
      window.addEventListener('resize', ajustar);
      if ('ResizeObserver' in window) new ResizeObserver(ajustar).observe(col);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', columnaFija);
    else columnaFija();

    /* Al volver con "atrás" desde el pago, "Comprar ahora" tiene que volver a funcionar. */
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-alp-comprar-ahora][aria-busy]').forEach(function (a) { a.removeAttribute('aria-busy'); });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilarBoton);
    else vigilarBoton();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alpaca-combina"] && !Shopify.designMode) return;
  try {
    /* «También te puede gustar» (Horizon) no repite lo que ya está en «Para sumar al regalo»,
     y muestra como máximo 4. Se ejecuta cuando Horizon termina de traer las recomendaciones. */
  (function () {
    function limpiar(pr) {
      var ya = {};
      document.querySelectorAll('.alp-combina__tarjeta[href]').forEach(function (a) {
        ya[a.getAttribute('href').split('?')[0]] = true;
      });
      var vistos = 0;
      pr.querySelectorAll('.resource-list__item').forEach(function (it) {
        var a = it.querySelector('a[href*="/products/"]');
        var h = a ? a.getAttribute('href').split('?')[0] : '';
        var fuera = ya[h] || vistos >= 4;
        it.hidden = fuera;
        if (!fuera) vistos++;
      });
    }
    function vigilar() {
      document.querySelectorAll('product-recommendations').forEach(function (pr) {
        limpiar(pr);
        new MutationObserver(function () { limpiar(pr); }).observe(pr, { childList: true, subtree: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilar);
    else vigilar();
  })();

  /* Ronda 5 · la caja de regalo: se abre una vez al entrar en pantalla y cuenta lo que se sumó con «Agregar»
     (assets/alpaca-carrito.js marca cada botón con data-sumado; aquí solo se mira, no se toca el carrito). */
  (function () {
    function cajas(raiz) {
      (raiz || document).querySelectorAll('[data-alp-caja]').forEach(function (caja) {
        if (caja.dataset.listo) return;
        caja.dataset.listo = '1';
        var sec = caja.closest('.alp-combina');
        var piezas = caja.querySelectorAll('.alp-caja__p[data-k]');
        function contar() {
          var n = sec ? Math.min(sec.querySelectorAll('[data-alp-sumar][data-sumado]').length, piezas.length) : 0;
          caja.style.setProperty('--n', n);
          piezas.forEach(function (pz) { pz.classList.toggle('alp-caja__p--en', Number(pz.getAttribute('data-k')) <= n); });
        }
        contar();
        if (sec && 'MutationObserver' in window) {
          new MutationObserver(contar).observe(sec, { subtree: true, attributes: true, attributeFilter: ['data-sumado'] });
        }
        if (!('IntersectionObserver' in window)) { caja.classList.add('alp-dib--va'); return; }
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { caja.classList.add('alp-dib--va'); io.disconnect(); } });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.5 });
        io.observe(caja);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { cajas(); });
    else cajas();
    document.addEventListener('shopify:section:load', function (e) { cajas(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alpaca-disenos"] && !Shopify.designMode) return;
  try {
    (function () {
    function nombre(caja, texto) {
      var b = caja.querySelector('[data-alp-disenos-nombre]');
      if (b) b.textContent = texto || b.getAttribute('data-actual') || '';
    }
    function sobre(ev) {
      var a = ev.target.closest && ev.target.closest('.alp-disenos__item');
      var caja = a && a.closest('[data-alp-disenos]');
      if (caja) nombre(caja, a.getAttribute('data-nombre'));
    }
    function fuera(ev) {
      var caja = ev.target.closest && ev.target.closest('[data-alp-disenos]');
      if (!caja) return;
      var hacia = ev.relatedTarget;
      if (hacia && caja.contains(hacia) && hacia.closest('.alp-disenos__item')) return;
      nombre(caja, '');
    }
    /* Ronda 3: espacio entre círculos para que el último visible asome a medias, y la fila arranca en el actual. */
    function ajustar(lista, primera) {
      var items = lista.children;
      if (!items.length) return;
      var s = items[0].getBoundingClientRect().width;
      var pad = parseFloat(getComputedStyle(lista).paddingLeft) || 0;
      var W = lista.clientWidth - pad;
      if (!s || !W) return;
      if (items.length * s + (items.length - 1) * 10 <= W) { lista.style.removeProperty('--alp-dis-gap'); return; }
      var n = Math.max(1, Math.floor((W - s / 2 + 10) / (s + 10)));
      var g = (W - s * 0.5 - n * s) / n;
      if (g < 6 && n > 1) { n -= 1; g = (W - s * 0.5 - n * s) / n; }
      g = Math.max(6, Math.min(g, 18));
      lista.style.setProperty('--alp-dis-gap', g.toFixed(1) + 'px');
      if (!primera) return;
      var act = lista.querySelector('[aria-current]');
      var li = act && act.closest('li');
      if (!li) return;
      var x = li.getBoundingClientRect().left - lista.getBoundingClientRect().left + lista.scrollLeft - pad;
      if (x + s > W - s * 0.5) lista.scrollLeft = Math.max(0, x - (s + g));
    }
    function todas(primera) {
      document.querySelectorAll('[data-alp-disenos] .alp-disenos__lista').forEach(function (l) { ajustar(l, primera); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { todas(true); });
    else todas(true);
    var espera = 0;
    window.addEventListener('resize', function () { clearTimeout(espera); espera = setTimeout(function () { todas(false); }, 150); });
    document.addEventListener('shopify:section:load', function () { todas(true); });

    document.addEventListener('mouseover', sobre);
    document.addEventListener('focusin', sobre);
    document.addEventListener('mouseout', fuera);
    document.addEventListener('focusout', fuera);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alpaca-envio"] && !Shopify.designMode) return;
  try {
    (function () {
    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var CLAVE = 'alpaca_ciudad';

    /* Hora de Ecuador (UTC−5, sin horario de verano), sin importar dónde esté la persona. */
    function ahoraEc() {
      var d = new Date(Date.now() - 5 * 3600e3);
      return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), dow: d.getUTCDay(), h: d.getUTCHours(), min: d.getUTCMinutes() };
    }
    function fecha(y, m, d) { return new Date(Date.UTC(y, m, d)); }
    function iso(f) { return f.toISOString().slice(0, 10); }
    function mas(f, n) { return new Date(f.getTime() + n * 864e5); }

    function datosFeriados(caja) {
      var l = (caja.getAttribute('data-feriados') || '').split(/[\s,;]+/).filter(Boolean);
      /* El carrito usa la misma lista para su fecha de llegada (assets/alpaca-carrito.js). */
      try { if (l.length) localStorage.setItem('alpaca_feriados', JSON.stringify(l)); } catch (e) {}
      return l;
    }
    /* Modo viaje sin reemplazo (12/10/2026): días sin Flash (metacampo alpaca.sin_flash, lo escribe el sistema).
       Flash se apaga desde las 9 p. m. del día anterior: después de las 9 p. m. se mira el día siguiente. */
    function datosSinFlash() {
      var c = document.querySelector('[data-alp-envio]');
      if (c) {
        var l = (c.getAttribute('data-sin-flash') || '').split(/[\s,;]+/).filter(function (x) { return /^\d{4}-\d{2}-\d{2}$/.test(x); });
        try { localStorage.setItem('alpaca_sin_flash', JSON.stringify(l)); } catch (e) {}
        return l;
      }
      try { return JSON.parse(localStorage.getItem('alpaca_sin_flash') || '[]') || []; } catch (e) { return []; }
    }
    function sinFlash(n) {
      n = n || ahoraEc();
      var f = fecha(n.y, n.m, n.d);
      if (n.h >= 21) f = mas(f, 1);
      return datosSinFlash().indexOf(iso(f)) >= 0;
    }
    /* Días de despacho: lunes a sábado, sin feriados. */
    function esDespacho(f, fer) { var w = f.getUTCDay(); return w >= 1 && w <= 6 && fer.indexOf(iso(f)) < 0; }

    function nombre(f, hoy) {
      var dif = Math.round((f - hoy) / 864e5);
      var base = DIAS[f.getUTCDay()] + ' ' + f.getUTCDate();
      if (dif === 0) return 'hoy, ' + base;
      if (dif === 1) return 'mañana, ' + base;
      return 'el ' + base;
    }

    /* Calcula cuándo llega por envío normal. */
    function calcular(fer, n0) {
      var n = n0 || ahoraEc(), hoy = fecha(n.y, n.m, n.d);
      /* Regla fija: sale el próximo día de despacho después de hoy (la hora no importa)… */
      var desp = mas(hoy, 1);
      while (!esDespacho(desp, fer)) desp = mas(desp, 1);
      /* …y llega al día siguiente del despacho, saltando domingos y feriados. */
      var lleg = mas(desp, 1);
      while (lleg.getUTCDay() === 0 || fer.indexOf(iso(lleg)) >= 0) lleg = mas(lleg, 1);
      var texto = 'Llega ' + nombre(lleg, hoy) + '.';
      return { texto: texto, cuenta: '', hoy: hoy, n: n, desp: desp, lleg: lleg, sab: null };
    }

    function quitar(t) {
      return t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z]+/g, ' ').trim();
    }

    /* Lugares conocidos: [cómo se escribe bien, tipo de envío, formas de escribirlo sin tildes].
       Galápagos y Quito van primero; el resto solo sirve para corregir el nombre al mostrarlo. */
    var LUGARES = [
      ['Galápagos', 'galapagos', ['galapagos', 'islas galapagos']],
      ['Santa Cruz, Galápagos', 'galapagos', ['santa cruz', 'puerto ayora']],
      ['San Cristóbal, Galápagos', 'galapagos', ['san cristobal', 'puerto baquerizo', 'baquerizo moreno']],
      ['Isabela, Galápagos', 'galapagos', ['isabela', 'puerto villamil']],
      ['Quito', 'quito', ['quito', 'kito', 'uio']],
      ['Cumbayá', 'quito', ['cumbaya']],
      ['Tumbaco', 'quito', ['tumbaco']],
      ['Los Chillos', 'quito', ['chillos', 'los chillos', 'valle de los chillos']],
      ['Sangolquí', 'quito', ['sangolqui']],
      ['Conocoto', 'quito', ['conocoto']],
      ['Alangasí', 'quito', ['alangasi']],
      ['Calderón', 'quito', ['calderon']],
      ['Carapungo', 'quito', ['carapungo']],
      ['Pomasqui', 'quito', ['pomasqui']],
      ['Nayón', 'quito', ['nayon']],
      ['Puembo', 'quito', ['puembo']],
      ['Pifo', 'quito', ['pifo']],
      ['Tababela', 'quito', ['tababela']],
      ['Amaguaña', 'quito', ['amaguana']],
      ['Guayaquil', 'resto', ['guayaquil']], ['Cuenca', 'resto', ['cuenca']], ['Ambato', 'resto', ['ambato']],
      ['Manta', 'resto', ['manta']], ['Portoviejo', 'resto', ['portoviejo']], ['Machala', 'resto', ['machala']],
      ['Loja', 'resto', ['loja']], ['Ibarra', 'resto', ['ibarra']], ['Riobamba', 'resto', ['riobamba']],
      ['Esmeraldas', 'resto', ['esmeraldas']], ['Santo Domingo', 'resto', ['santo domingo']],
      ['Latacunga', 'resto', ['latacunga']], ['Otavalo', 'resto', ['otavalo']], ['Babahoyo', 'resto', ['babahoyo']],
      ['Quevedo', 'resto', ['quevedo']], ['Milagro', 'resto', ['milagro']], ['Tulcán', 'resto', ['tulcan']],
      ['Salinas', 'resto', ['salinas']], ['Santa Elena', 'resto', ['santa elena']], ['Durán', 'resto', ['duran']],
      ['Samborondón', 'resto', ['samborondon']], ['Azogues', 'resto', ['azogues']], ['Puyo', 'resto', ['puyo']],
      ['Tena', 'resto', ['tena']], ['Macas', 'resto', ['macas']], ['Lago Agrio', 'resto', ['lago agrio']],
      ['Coca', 'resto', ['coca']], ['Zamora', 'resto', ['zamora']]
    ];

    /* Distancia entre dos palabras: letras cambiadas, de más, de menos o invertidas. */
    function distancia(a, b) {
      var d = [], i, j;
      for (i = 0; i <= a.length; i++) d[i] = [i];
      for (j = 0; j <= b.length; j++) d[0][j] = j;
      for (i = 1; i <= a.length; i++) {
        for (j = 1; j <= b.length; j++) {
          d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
      return d[a.length][b.length];
    }

    /* Tolerancia a errores: nombres cortos tienen que ir bien escritos (para no confundir Nayón con Nabón);
       Quito acepta un error; nombres medianos, uno; largos, dos. */
    function tolerancia(v) {
      if (v === 'quito') return 1;
      return v.length <= 5 ? 0 : v.length <= 7 ? 1 : 2;
    }

    function bonito(c) {
      var menores = ['de', 'del', 'la', 'las', 'los', 'y', 'el'];
      return c.trim().replace(/\s+/g, ' ').split(' ').map(function (p, i) {
        var b = p.toLowerCase();
        return i > 0 && menores.indexOf(b) >= 0 ? b : b.charAt(0).toUpperCase() + b.slice(1);
      }).join(' ');
    }

    /* Busca la ciudad aunque venga con errores. Primero exacta, después con tolerancia. */
    function buscar(c) {
      var t = quitar(c);
      if (!t) return c.trim() ? { tipo: 'resto', nombre: c.trim().slice(0, 40) } : null;
      var w = t.split(' ');
      for (var pase = 0; pase < 2; pase++) {
        for (var a = 0; a < LUGARES.length; a++) {
          var L = LUGARES[a];
          for (var b = 0; b < L[2].length; b++) {
            var v = L[2][b], k = v.split(' ').length;
            var tol = pase === 0 ? 0 : tolerancia(v);
            if (pase === 1 && tol === 0) continue;
            for (var i = 0; i + k <= w.length; i++) {
              var g = w.slice(i, i + k).join(' ');
              if (Math.abs(g.length - v.length) > tol) continue;
              if (distancia(g, v) <= tol) return { tipo: L[1], nombre: k === w.length ? L[0] : bonito(c) };
            }
          }
        }
      }
      return { tipo: 'resto', nombre: bonito(c) };
    }

    function pintar(caja) {
      var fer = datosFeriados(caja), r = calcular(fer);
      var ciudad = '';
      try { ciudad = localStorage.getItem(CLAVE) || ''; } catch (e) {}
      var lugar = ciudad ? (buscar(ciudad) || { tipo: 'resto', nombre: ciudad }) : null;
      var tipo = lugar ? lugar.tipo : '';
      var precio = tipo === 'quito' ? (caja.dataset.precioQuito || '$4.99') : (caja.dataset.precioResto || '$5.50');
      var mismo = caja.dataset.precioMismoDia || '$8.50';
      var fechaEl = caja.querySelector('[data-alp-envio-fecha]');
      var precioEl = caja.querySelector('[data-alp-envio-precio]');
      var ciudadEl = caja.querySelector('[data-alp-envio-ciudad]');
      var res = caja.querySelector('[data-alp-envio-resultado]');
      var cuentaEl = caja.querySelector('[data-alp-envio-cuenta]');
      var cuentaTxt = tipo === 'galapagos' ? '' : r.cuenta;
      if (cuentaEl) {
        if (cuentaEl.textContent !== cuentaTxt) cuentaEl.textContent = cuentaTxt;
        cuentaEl.hidden = !cuentaTxt;
      }

      var ficha = caja.classList.contains('alp-envio-caja--ficha');
      if (tipo === 'galapagos') {
        fechaEl.textContent = ficha ? 'te confirmamos fecha y costo' : 'A ' + lugar.nombre + ': tarda unos días más.';
        precioEl.textContent = ficha ? 'Envío a Galápagos' : 'Te confirmamos fecha y costo por WhatsApp.';
      } else {
        var t = r.texto;
        /* En la píldora de la ficha: «+ envío $5.50 · llega el martes 13» (sin mayúscula ni punto final). */
        if (ficha) {
          fechaEl.textContent = t.charAt(0).toLowerCase() + t.slice(1).replace(/\.$/, '');
          precioEl.textContent = '+ envío ' + precio;
        } else {
          fechaEl.textContent = (ciudad ? 'A ' + lugar.nombre + ': ' + t.charAt(0).toLowerCase() + t.slice(1) : t);
          precioEl.textContent = 'Envío ' + precio;
        }
      }
      if (ciudadEl) ciudadEl.textContent = ciudad ? 'Cambiar ciudad' : 'Ver para tu ciudad';

      var firma = ciudad + '|' + r.texto + '|' + (r.n.h < 21);
      if (res && res.dataset.ultimo !== firma) {
        res.dataset.ultimo = firma;
        res.innerHTML = '';
        if (!ciudad) return;
        var p1 = document.createElement('p'), p2 = document.createElement('p');
        if (tipo === 'galapagos') {
          p1.textContent = 'A ' + lugar.nombre + ' el envío tarda unos días más.';
          p2.textContent = 'Escríbenos por WhatsApp y te confirmamos la fecha y el costo exactos.';
        } else {
          p1.innerHTML = '<strong></strong>';
          p1.firstChild.textContent = 'A ' + lugar.nombre + ': ' + r.texto.charAt(0).toLowerCase() + r.texto.slice(1) + ' Envío ' + precio + '.';
          if (tipo === 'quito' && !sinFlash(r.n)) {
            p2.textContent = r.n.h < 21 ? '¿Lo necesitas hoy? Al pagar elige «Alpaca Flash» (' + mismo + '), antes de las 9 p. m.' : 'Para el mismo día está «Alpaca Flash» (' + mismo + '): se pide hasta las 9 p. m.';
          }
        }
        res.appendChild(p1);
        if (p2.textContent) res.appendChild(p2);
      }
    }

    /* Motor de envío a la vista de otras piezas (la portada calcula con él la fecha límite de las ocasiones). */
    window.AlpacaEnvio = {
      calcular: calcular,
      sinFlash: sinFlash,
      ahora: ahoraEc,
      buscar: buscar,
      feriados: function () { var c = document.querySelector('[data-alp-envio]'); return c ? datosFeriados(c) : []; },
      lugar: function () { var c = ''; try { c = localStorage.getItem(CLAVE) || ''; } catch (e) {} return c ? (buscar(c) || { tipo: 'resto', nombre: c }) : null; }
    };

    function iniciar() {
      document.querySelectorAll('[data-alp-envio]').forEach(function (caja) {
        if (caja.dataset.listo) return;
        caja.dataset.listo = '1';
        var form = caja.querySelector('[data-alp-envio-form]');
        var input = form && form.querySelector('input');
        try { if (input) input.value = localStorage.getItem(CLAVE) || ''; } catch (e) {}
        if (form) form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = (input.value || '').trim().slice(0, 40);
          var l = v ? buscar(v) : null;
          if (l) { v = l.nombre.slice(0, 40); input.value = v; }
          input.blur();
          try { if (v) localStorage.setItem(CLAVE, v); else localStorage.removeItem(CLAVE); } catch (er) {}
          var res0 = caja.querySelector('[data-alp-envio-resultado]');
          if (res0) delete res0.dataset.ultimo;
          pintar(caja);
          try { window.dispatchEvent(new CustomEvent('alpaca:ciudad')); } catch (er2) {}
        });
        pintar(caja);
        setInterval(function () { if (!document.hidden) pintar(caja); }, 60000);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alpaca-etiqueta"] && !Shopify.designMode) return;
  try {
    (function () {
    var NS = 'http://www.w3.org/2000/svg';
    /* v2: dibujo en tinta sobre el fondo niebla; la prenda en arena, la persona en piedra (silueta quieta). */
    var PAPEL = '#0c1d3a', MOSTAZA = '#56637a', TELA = '#f2daaa', CUERPO = '#b4b9c2', CABEZA = '#b4b9c2';

    function nodo(tag, attrs, padre) {
      var e = document.createElementNS(NS, tag);
      for (var k in attrs) e.setAttribute(k, attrs[k]);
      if (padre) padre.appendChild(e);
      return e;
    }
    function metros(cm) { return (cm / 100).toFixed(2).replace('.', ',') + ' m'; }
    function cmTxt(cm) { return cm >= 100 && cm % 5 === 0 && cm > 150 ? metros(cm) : Math.round(cm) + ' cm'; }

    /* Dónde cae el borde, según la estatura (proporciones promedio del cuerpo). */
    function altura(r) {
      if (r < 0.16) return 'casi hasta el tobillo';
      if (r < 0.22) return 'a media pantorrilla';
      if (r < 0.27) return 'justo debajo de la rodilla';
      if (r < 0.31) return 'a la altura de la rodilla';
      if (r < 0.40) return 'un poco arriba de la rodilla';
      if (r < 0.48) return 'a medio muslo';
      return 'a la cadera';
    }

    function persona(g, H, X, Y) {
      var c = CUERPO;
      var cab = 0.062 * H, ent = 0.47 * H, pie = 0.035 * H;
      var pierna = 0.058 * H, sep = 0.008 * H;
      /* piernas */
      nodo('path', { d: 'M' + X(-sep - pierna) + ' ' + Y(ent) + 'L' + X(-sep - pierna * 0.72) + ' ' + Y(pie) + 'L' + X(-sep - pierna * 1.15) + ' ' + Y(0) + 'H' + X(-sep) + 'V' + Y(ent) + 'Z', fill: c }, g);
      nodo('path', { d: 'M' + X(sep + pierna) + ' ' + Y(ent) + 'L' + X(sep + pierna * 0.72) + ' ' + Y(pie) + 'L' + X(sep + pierna * 1.15) + ' ' + Y(0) + 'H' + X(sep) + 'V' + Y(ent) + 'Z', fill: c }, g);
      /* torso y brazos (se ven si la prenda es corta) */
      nodo('path', { d: 'M' + X(-0.125 * H) + ' ' + Y(0.815 * H) + 'Q' + X(-0.14 * H) + ' ' + Y(0.7 * H) + ' ' + X(-0.115 * H) + ' ' + Y(0.5 * H) + 'H' + X(0.115 * H) + 'Q' + X(0.14 * H) + ' ' + Y(0.7 * H) + ' ' + X(0.125 * H) + ' ' + Y(0.815 * H) + 'Z', fill: c }, g);
      return { cab: cab };
    }

    function cabeza(g, H, X, Y) {
      var cab = 0.062 * H;
      nodo('rect', { x: X(-0.028 * H), y: Y(0.875 * H), width: (0.056 * H * escala(g)).toFixed(1), height: (0.06 * H * escala(g)).toFixed(1), fill: CUERPO }, g);
      nodo('ellipse', { cx: X(0), cy: Y(H - cab * 1.05), rx: (cab * 0.8 * escala(g)).toFixed(1), ry: (cab * 1.05 * escala(g)).toFixed(1), fill: CABEZA }, g);
    }
    function escala(g) { return Number(g.getAttribute('data-s')); }

    function flecos(g, x1, x2, y, s) {
      var d = '';
      for (var x = x1 + 2; x < x2 - 1; x += 3.2) d += 'M' + x.toFixed(1) + ' ' + y.toFixed(1) + 'v' + (3.2 * s).toFixed(1);
      nodo('path', { d: d, stroke: PAPEL, 'stroke-width': 0.8, 'stroke-opacity': 0.8 }, g);
    }

    function cota(svg, x, y1, y2, texto) {
      nodo('path', { d: 'M' + (x - 4) + ' ' + y1 + 'h8M' + (x - 4) + ' ' + y2 + 'h8M' + x + ' ' + y1 + 'V' + y2, stroke: MOSTAZA, 'stroke-width': 1.2, fill: 'none' }, svg);
      var t = nodo('text', { x: x + 8, y: ((Number(y1) + Number(y2)) / 2 + 4).toFixed(1) }, svg);
      t.textContent = texto;
    }

    function dibujarPrenda(caja, svg, H) {
      var tipo = caja.dataset.tipo, L = Number(caja.dataset.largo), W = Number(caja.dataset.ancho);
      var s = 1.08, piso = 226, cx = 140;
      svg.setAttribute('viewBox', svg.getAttribute('data-vista-persona') || '0 0 300 240');
      function X(cm) { return (cx + cm * s).toFixed(1); }
      function Y(cm) { return (piso - cm * s).toFixed(1); }
      var g = nodo('g', { 'data-s': s }, svg);
      persona(g, H, X, Y);
      var hombro = 0.818 * H, hm = 0.125 * H, cuello = 0.045 * H, borde;

      if (tipo === 'poncho') {
        borde = hombro - L;
        /* capucha detrás de la cabeza */
        nodo('path', { d: 'M' + X(-0.085 * H) + ' ' + Y(hombro + 0.01 * H) + 'Q' + X(-0.095 * H) + ' ' + Y(0.98 * H) + ' ' + X(0) + ' ' + Y(0.985 * H) + 'Q' + X(0.095 * H) + ' ' + Y(0.98 * H) + ' ' + X(0.085 * H) + ' ' + Y(hombro + 0.01 * H) + 'Z', fill: PAPEL, 'fill-opacity': 0.08, stroke: PAPEL, 'stroke-opacity': 0.7, 'stroke-width': 1, 'stroke-linejoin': 'round' }, g);
        cabeza(g, H, X, Y);
        /* Vista de frente, como en las fotos: cae desde los hombros, cubre los brazos y se abre un poco a la altura de los codos. */
        var f = Math.max(0.85, Math.min(1.15, W / 126));
        var ws = 0.18 * H * f, wc = 0.235 * H * f, wh = 0.215 * H * f, codo = hombro - 0.22 * H, punta = wh + 0.02 * H;
        if (codo < borde + 0.04 * H) codo = borde + 0.04 * H;
        var d = 'M' + X(-cuello) + ' ' + Y(hombro + 0.022 * H) +
          'Q' + X(-ws * 0.7) + ' ' + Y(hombro + 0.02 * H) + ' ' + X(-ws) + ' ' + Y(hombro - 0.02 * H) +
          'C' + X(-ws - 0.02 * H) + ' ' + Y(hombro - 0.1 * H) + ' ' + X(-wc) + ' ' + Y(codo + 0.07 * H) + ' ' + X(-wc) + ' ' + Y(codo) +
          'L' + X(-punta) + ' ' + Y(borde - 0.012 * H) +
          'Q' + X(-wh * 0.5) + ' ' + Y(borde + 0.004 * H) + ' ' + X(0) + ' ' + Y(borde) +
          'Q' + X(wh * 0.5) + ' ' + Y(borde + 0.004 * H) + ' ' + X(punta) + ' ' + Y(borde - 0.012 * H) +
          'L' + X(wc) + ' ' + Y(codo) +
          'C' + X(wc) + ' ' + Y(codo + 0.07 * H) + ' ' + X(ws + 0.02 * H) + ' ' + Y(hombro - 0.1 * H) + ' ' + X(ws) + ' ' + Y(hombro - 0.02 * H) +
          'Q' + X(ws * 0.7) + ' ' + Y(hombro + 0.02 * H) + ' ' + X(cuello) + ' ' + Y(hombro + 0.022 * H) + 'Z';
        nodo('path', { d: d, fill: TELA, stroke: PAPEL, 'stroke-width': 1.3, 'stroke-linejoin': 'round' }, g);
        if (caja.dataset.corte === 'abierto') {
          /* abierto adelante: la abertura llega hasta abajo y se cierra con un botón en el cuello */
          nodo('path', { d: 'M' + X(0) + ' ' + Y(hombro + 0.02 * H) + 'V' + Y(borde), stroke: PAPEL, 'stroke-width': 1, 'stroke-opacity': 0.75 }, g);
          nodo('circle', { cx: X(0), cy: Y(hombro - 0.02 * H), r: 1.8, fill: PAPEL }, g);
        } else {
          /* cerrado: solo la abertura del cuello */
          nodo('path', { d: 'M' + X(0) + ' ' + Y(hombro + 0.02 * H) + 'V' + Y(hombro - 0.06 * H), stroke: PAPEL, 'stroke-width': 1, 'stroke-opacity': 0.6 }, g);
        }
        flecos(g, Number(X(-punta)), Number(X(punta)), Number(Y(borde - 0.004 * H)), s);
        cota(svg, Number(X(wc)) + 12, Y(hombro), Y(borde), L + ' cm');
        return 'Con ' + metros(H) + ', este poncho te llega ' + altura(borde / H) + '.';
      }

      /* chal sobre los hombros, con las puntas hacia adelante */
      var colgado = Math.max(20, (L - 0.3 * H) / 2);
      borde = hombro - colgado;
      var pw = Math.min(W * 0.25, 15), x0 = hm + 1;
      cabeza(g, H, X, Y);
      nodo('path', { d: 'M' + X(-x0) + ' ' + Y(hombro + 0.03 * H) + 'Q' + X(0) + ' ' + Y(hombro + 0.06 * H) + ' ' + X(x0) + ' ' + Y(hombro + 0.03 * H) + 'V' + Y(hombro - 0.02 * H) + 'Q' + X(0) + ' ' + Y(hombro + 0.01 * H) + ' ' + X(-x0) + ' ' + Y(hombro - 0.02 * H) + 'Z', fill: TELA, stroke: PAPEL, 'stroke-width': 1.1, 'stroke-linejoin': 'round' }, g);
      nodo('path', { d: 'M' + X(-x0) + ' ' + Y(hombro + 0.03 * H) + 'H' + X(-x0 + pw) + 'L' + X(-x0 + pw) + ' ' + Y(borde) + 'H' + X(-x0) + 'Z', fill: TELA, stroke: PAPEL, 'stroke-width': 1.3, 'stroke-linejoin': 'round' }, g);
      nodo('path', { d: 'M' + X(x0) + ' ' + Y(hombro + 0.03 * H) + 'H' + X(x0 - pw) + 'L' + X(x0 - pw) + ' ' + Y(borde) + 'H' + X(x0) + 'Z', fill: TELA, stroke: PAPEL, 'stroke-width': 1.3, 'stroke-linejoin': 'round' }, g);
      flecos(g, Number(X(-x0)), Number(X(-x0 + pw)), Number(Y(borde)), s);
      flecos(g, Number(X(x0 - pw)), Number(X(x0)), Number(Y(borde)), s);
      cota(svg, Number(X(x0)) + 14, Y(hombro), Y(borde), Math.round(colgado) + ' cm');
      return 'Con ' + metros(H) + ', las puntas del chal te llegan ' + altura(borde / H) + '.';
    }

    function dibujarCama(caja, svg, cama) {
      var L = Number(caja.dataset.largo), W = Number(caja.dataset.ancho);
      var bw = cama[0], bl = cama[1], s = 0.82, ox = 150, oy = 14;
      function X(cm) { return (ox + cm * s).toFixed(1); }
      function Y(cm) { return (oy + cm * s).toFixed(1); }
      var cabecera = 6, inicio = 30;
      nodo('rect', { x: X(-bw / 2), y: Y(0), width: (bw * s).toFixed(1), height: (cabecera * s).toFixed(1), fill: PAPEL, 'fill-opacity': 0.5 }, svg);
      nodo('rect', { x: X(-bw / 2), y: Y(cabecera), width: (bw * s).toFixed(1), height: ((bl - cabecera) * s).toFixed(1), fill: 'none', stroke: PAPEL, 'stroke-opacity': 0.55, 'stroke-dasharray': '4 3' }, svg);
      var almohadas = bw >= 135 ? 2 : 1, aw = (bw - 12 - (almohadas - 1) * 6) / almohadas;
      for (var i = 0; i < almohadas; i++) nodo('rect', { x: X(-bw / 2 + 6 + i * (aw + 6)), y: Y(cabecera + 4), width: (aw * s).toFixed(1), height: (16 * s).toFixed(1), rx: 3, fill: PAPEL, 'fill-opacity': 0.3 }, svg);
      var largoVisible = Math.min(L, bl - inicio + 60);
      nodo('rect', { x: X(-W / 2), y: Y(inicio), width: (W * s).toFixed(1), height: (largoVisible * s).toFixed(1), fill: TELA, stroke: PAPEL, 'stroke-width': 1.3 }, svg);
      var lado = (W - bw) / 2;
      var t = nodo('text', { x: X(0), y: (Number(Y(inicio + largoVisible)) + 14).toFixed(1), 'text-anchor': 'middle' }, svg);
      t.textContent = metros(W);
      /* El largo, en vertical al costado derecho de la cobija. */
      var lx = (Number(X(W / 2)) + 12).toFixed(1), ly = (Number(Y(inicio)) + largoVisible * s / 2).toFixed(1);
      var t2 = nodo('text', { x: lx, y: ly, 'text-anchor': 'middle', transform: 'rotate(90 ' + lx + ' ' + ly + ')' }, svg);
      t2.textContent = metros(L);
      var nombre = bw === 100 ? '1 plaza' : bw === 135 ? 'plaza y media' : '2 plazas';
      if (lado >= 3) return 'En una cama de ' + nombre + ' (' + metros(bl).replace(' m', '') + ' × ' + metros(bw).replace(' ', ' ') + ') cuelga ' + Math.round(lado) + ' cm por cada lado.';
      if (lado > -3) return 'En una cama de ' + nombre + ' (' + metros(bl).replace(' m', '') + ' × ' + metros(bw).replace(' ', ' ') + ') queda justa, sin colgar por los lados.';
      return 'En una cama de ' + nombre + ' (' + metros(bl).replace(' m', '') + ' × ' + metros(bw).replace(' ', ' ') + ') no alcanza a cubrir los lados.';
    }

    function pintar(caja) {
      var svg = caja.querySelector('.alp-queda__dibujo');
      var frase = caja.querySelector('.alp-queda__frase');
      if (!svg) return;
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var texto;
      if (caja.dataset.tipo === 'cobija') {
        var b = caja.querySelector('[data-cama][aria-pressed="true"]');
        var medidas = (b ? b.getAttribute('data-cama') : '135x190').split('x').map(Number);
        svg.setAttribute('viewBox', '0 0 300 240');
        texto = dibujarCama(caja, svg, medidas);
      } else {
        var r = caja.querySelector('input[type="range"]');
        var H = Number(r.value);
        var out = caja.querySelector('output');
        if (out) out.textContent = metros(H);
        nodo('path', { d: 'M50 226.5H250', stroke: PAPEL, 'stroke-opacity': 0.3 }, svg);
        texto = dibujarPrenda(caja, svg, H);
      }
      var rr = caja.querySelector('input[type="range"]');
      if (rr) rr.setAttribute('aria-valuetext', metros(Number(rr.value)) + '. ' + texto);
      if (frase) frase.textContent = texto;
    }

    /* «Ver cómo te queda» desde arriba (junto al precio): abre el dibujo y lleva hasta él. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-alp-ver-queda]');
      if (!a) return;
      var q = document.querySelector('[data-alp-queda]');
      if (!q) return;
      e.preventDefault();
      if (!q.open) q.open = true;
      var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var destino = q.closest('.alp-etiqueta__g') || q;
      destino.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
      /* Si el navegador no animó el desplazamiento (pestaña en segundo plano, etc.), salta directo. */
      setTimeout(function () {
        var y = destino.getBoundingClientRect().top;
        if (y < 0 || y > window.innerHeight * 0.5) destino.scrollIntoView({ behavior: 'instant', block: 'start' });
      }, 900);
      var s = q.querySelector('summary');
      if (s) s.focus({ preventScroll: true });
    });

    function iniciar(raiz) {
      (raiz || document).querySelectorAll('[data-alp-queda]').forEach(function (caja) {
        if (caja.dataset.listo) return;
        caja.dataset.listo = '1';
        caja.addEventListener('toggle', function () { if (caja.open) pintar(caja); });
        caja.addEventListener('input', function (e) { if (e.target.matches('input[type="range"]')) pintar(caja); });
        caja.addEventListener('click', function (e) {
          var paso = e.target.closest && e.target.closest('[data-paso]');
          if (paso) {
            var rg = caja.querySelector('input[type="range"]');
            if (rg) {
              rg.value = Math.min(Number(rg.max), Math.max(Number(rg.min), Number(rg.value) + Number(paso.getAttribute('data-paso'))));
              pintar(caja);
            }
            return;
          }
          var b = e.target.closest && e.target.closest('[data-cama]');
          if (!b) return;
          caja.querySelectorAll('[data-cama]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          pintar(caja);
        });
        if (caja.open) pintar(caja);
      });
    }

    /* Ronda 5: la barra, los ovillos y el mapita se dibujan una vez, al entrar en pantalla (ver el CSS). */
    function dibujar(raiz) {
      var els = (raiz || document).querySelectorAll('[data-alp-dibuja]:not(.alp-dib--va)');
      if (!els.length) return;
      /* Una cosa por vez: si las dos tarjetas entran juntas, el mapita espera a que termine la barra. */
      var libre = 0;
      function va(el) {
        var ahora = Date.now(), espera = Math.max(0, libre - ahora);
        libre = ahora + espera + 900;
        setTimeout(function () { el.classList.add('alp-dib--va'); }, espera);
      }
      if (!('IntersectionObserver' in window)) { els.forEach(va); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { va(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.25 });
      els.forEach(function (el) { io.observe(el); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); dibujar(); });
    else { iniciar(); dibujar(); }
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); dibujar(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alpaca-razones"] && !Shopify.designMode) return;
  try {
    (function () {
    /* La fecha real, del mismo motor de la píldora de envío (window.AlpacaEnvio, blocks/alpaca-envio). */
    function pintar() {
      var E = window.AlpacaEnvio;
      var els = document.querySelectorAll('[data-alp-razones-fecha]');
      if (!E || !els.length) return;
      var txt = '';
      try {
        var lugar = E.lugar ? E.lugar() : null;
        if (lugar && lugar.tipo === 'galapagos') {
          txt = 'a Galápagos: te confirmamos la fecha';
        } else {
          var r = E.calcular(E.feriados());
          txt = r.texto.replace(/^Llega\s+/, '').replace(/\.$/, '');
        }
      } catch (e) { return; }
      if (!txt) return;
      els.forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
    }

    /* «llega…» abre el panel de la ciudad del envío. */
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-alp-razones-llega]');
      if (!b) return;
      var raiz = b.closest('.product-details') || document;
      var chip = raiz.querySelector('[data-alp-envio] [data-alp-abrir]') || document.querySelector('[data-alp-envio] [data-alp-abrir]');
      if (chip) chip.click();
    });

    function iniciar() {
      pintar();
      setInterval(function () { if (!document.hidden) pintar(); }, 60000);
    }
    window.addEventListener('alpaca:ciudad', pintar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
    window.addEventListener('load', pintar);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alpaca-regalo"] && !Shopify.designMode) return;
  try {
    (function () {
    function sincronizar(caja) {
      var si = caja.querySelector('[data-alp-regalo-si]');
      var texto = caja.querySelector('[data-alp-regalo-texto]');
      var prop = caja.querySelector('[data-alp-regalo-prop]');
      var msj = caja.querySelector('[data-alp-regalo-msj]');
      var cuenta = caja.querySelector('[data-alp-regalo-cuenta]');
      var activo = si.checked;
      var valor = (texto.value || '').replace(/[^\S\n]+/g, ' ').replace(/\n{3,}/g, '\n\n').trim();
      prop.disabled = !activo;
      msj.value = valor;
      msj.disabled = !activo || !valor;
      var resta = Number(texto.getAttribute('maxlength')) - texto.value.length;
      cuenta.textContent = resta <= 40 ? 'Te quedan ' + resta : '';
      /* Al lector de pantalla solo se le avisa en 40, 20 y 0, no con cada letra. */
      var aviso = caja.querySelector('[data-alp-regalo-aviso]');
      if (aviso && (resta === 40 || resta === 20 || resta === 0)) aviso.textContent = 'Te quedan ' + resta + ' letras';
    }

    function iniciar(raiz) {
      (raiz || document).querySelectorAll('[data-alp-regalo]').forEach(function (caja) {
        if (caja.dataset.listo) return;
        caja.dataset.listo = '1';
        var si = caja.querySelector('[data-alp-regalo-si]');
        var abrir = caja.querySelector('.alp-regalo__caja');
        if (!si || !abrir) return;
        si.addEventListener('change', function () {
          abrir.hidden = !si.checked;
          si.setAttribute('aria-expanded', si.checked ? 'true' : 'false');
          sincronizar(caja);
        });
        caja.addEventListener('input', function () { sincronizar(caja); });
        sincronizar(caja);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    else iniciar();
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alpaca-resenas"] && !Shopify.designMode) return;
  try {
    /* Ronda 3 · la fila de opiniones sin fin: dos copias de la lista (antes y después), ocultas para lectores de pantalla
     y fuera del orden del teclado; la fila arranca en la del medio. Al soltar (scrollend o una pausa), si quedó en una
     copia de los bordes vuelve al mismo punto de la del medio: es idéntico, así que el salto no se ve. Nada se mueve solo.
     (La misma idea que «Lo que nos escriben» de la portada, assets/alpaca-portada.js.) */
  (function () {
    function sinFin(f) {
      if (f.getAttribute('data-alp-sin-fin-va')) return;
      var orig = Array.prototype.slice.call(f.children);
      if (orig.length < 3 || f.scrollWidth <= f.clientWidth + 4) return;
      f.setAttribute('data-alp-sin-fin-va', '1');
      orig.forEach(function (li) { li.setAttribute('data-alp-copia', '1'); });
      function copia(n) {
        var frag = document.createDocumentFragment();
        orig.forEach(function (li) {
          var c = li.cloneNode(true);
          c.setAttribute('data-alp-copia', String(n));
          c.setAttribute('aria-hidden', 'true');
          Array.prototype.forEach.call(c.querySelectorAll('a, button, input, [tabindex]'), function (x) { x.setAttribute('tabindex', '-1'); });
          Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (x) { x.removeAttribute('id'); });
          frag.appendChild(c);
        });
        return frag;
      }
      f.insertBefore(copia(0), f.firstChild);
      f.appendChild(copia(2));
      function ancho() {
        var a = f.querySelector('[data-alp-copia="0"]'), b = f.querySelector('[data-alp-copia="1"]');
        return a && b ? b.offsetLeft - a.offsetLeft : 0;
      }
      function mover(x) {
        var antes = f.style.scrollBehavior;
        f.style.scrollBehavior = 'auto';
        f.scrollLeft = x;
        f.style.scrollBehavior = antes;
      }
      function centrar() {
        var w = ancho();
        if (!w) return;
        var x = f.scrollLeft;
        if (x < w * 0.5) mover(x + w);
        else if (x >= w * 1.5) mover(x - w);
      }
      mover(f.scrollLeft + ancho());
      var tocando = false, espera = 0;
      f.addEventListener('touchstart', function () { tocando = true; }, { passive: true });
      f.addEventListener('touchend', function () { tocando = false; }, { passive: true });
      f.addEventListener('touchcancel', function () { tocando = false; }, { passive: true });
      if ('onscrollend' in window) {
        f.addEventListener('scrollend', function () { if (!tocando) centrar(); });
      } else {
        f.addEventListener('scroll', function () {
          clearTimeout(espera);
          espera = setTimeout(function () { if (!tocando) centrar(); }, 220);
        }, { passive: true });
      }
      window.addEventListener('resize', function () { clearTimeout(espera); espera = setTimeout(centrar, 200); });
    }
    function iniciar(raiz) {
      (raiz || document).querySelectorAll('[data-alp-resenas-fila]').forEach(sinFin);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    else iniciar();
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
